
import { computed, defineComponent, PropType, reactive } from 'vue'

// types
import { TabT } from '@/core/types/components.types'

export default defineComponent({
    props: {
        tabs: {
            type: Array as PropType<TabT[]>,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isSubTab: {
            type: Boolean,
            default: false,
        },
        isNew: {
            type: Boolean,
            default: false,
        },
        isLink: {
            type: Boolean,
            default: true,
        },
        isSmall: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['clicked'],
    setup(props, { emit }) {
        const state = reactive({
            current_id: 1,
        })

        const computedClasses = computed(() => {
            return {
                'tabs--small': props.tabs.length >= 5 || props.isSmall,
            }
        })

        const emitClick = (id: number) => {
            state.current_id = id
            emit('clicked', id)
        }

        return { state, computedClasses, emitClick }
    },
})
